export type CapabilityFlag =
  | "canUseManagerAgent"
  | "canUseManagerWorkflows"
  | "canUseManagerAutopilot"
  | "canUseManagerTimelineAdvanced"
  | "canUseNextActionsAI"
  | "canUseBookingAI"
  | "canUseLeadScoring"
  | "canUseEmailAI"
  | "canUseCrmEmailAI"
  | "canUseRoutingAdvisor"
  | "canUseRoutingStrategies"
  | "canUseRoutingOsrm"
  | "canGenerateRoutingLeads"
  | "canViewRoutingWarnings"
  | "canUseCrmAI"
  | "canUseCrmInsights"
  | "canUseCrmLeadAutomation"
  | "canUseCrmEventAutomation"
  | "canUseCrmDedupe"
  | "canUseTemplateAutomation"
  | "canUseCrmTemplateAutomation"
  | "canUseCrmIngestion"
  | "crm_enrich"
  | "booking_enrichment"
  | "venue_digest"
  | "canUseAdvancedHitl"
  | "canApproveHitl"
  | "canRejectHitl"
  | "canRequestChangesHitl"
  | "canAssignHitl"
  | "canViewHitlWorkflowContext"
  | "canViewHitlTimeline"
  | "canViewHitl"
  | "canOpenHitlDrawer"
  | "canResolveHitlItem"
  | "canUseHitlNarratives"
  | "canUseHitlContext"
  | "canUseRoutingAI"
  | "canUseRoutingAutopilot"
  | "canUseLedgerAutomation"
  | "canUseSettlementPreview"
  | "canUseAccountingAI"
  | "canEditWorkflows"
  | "canCreateWorkflows"
  | "canUseMemoryBrowser"
  | "canUseMemoryGraph"
  | "canUsePublicistAI"
  | "canUsePressAutomation"
  | "canUseOutletVariants"
  | "canUsePressAnalytics"
  | "canUseLeadDigestor"
  | "canUseArticleEnrichment"
  | "canUseDraftToneTools"
  | "canUseDraftRewriteTools"
  | "canUseDraftVariableAutomation"
  | "canUsePressCampaigns"
  | "canUsePressGraphLinks"
  | "canUseMarketingAI"
  | "canUseMarketingAutopilot"
  | "canUseMixboardAI"
  | "canUseMcpTasks"
  | "canUseGlobalAutopilot"
  | "canRunAiTasks"
  | "autopilot_view"
  | "autopilot_manage"
  | "canRunMasterAutopilot"
  | "canRunMasterDigest"
  | "canDelegateAgents"
  | "observability.frontend"
  | "observability.digest"
  | "plan.plus";

export type Capabilities = Record<CapabilityFlag, boolean> & {
  [key: string]: boolean;
};

export const CAPABILITY_FLAGS: CapabilityFlag[] = [
  "canUseManagerAgent",
  "canUseManagerWorkflows",
  "canUseManagerAutopilot",
  "canUseManagerTimelineAdvanced",
  "canUseNextActionsAI",
  "canUseBookingAI",
  "canUseLeadScoring",
  "canUseEmailAI",
  "canUseCrmEmailAI",
  "canUseRoutingAdvisor",
  "canUseRoutingStrategies",
  "canUseRoutingOsrm",
  "canGenerateRoutingLeads",
  "canViewRoutingWarnings",
  "canUseCrmAI",
  "canUseCrmInsights",
  "canUseCrmLeadAutomation",
  "canUseCrmEventAutomation",
  "canUseCrmDedupe",
  "canUseTemplateAutomation",
  "canUseCrmTemplateAutomation",
  "canUseCrmIngestion",
  "crm_enrich",
  "booking_enrichment",
  "venue_digest",
  "canUseAdvancedHitl",
  "canApproveHitl",
  "canRejectHitl",
  "canRequestChangesHitl",
  "canAssignHitl",
  "canViewHitlWorkflowContext",
  "canViewHitlTimeline",
  "canViewHitl",
  "canOpenHitlDrawer",
  "canResolveHitlItem",
  "canUseHitlNarratives",
  "canUseHitlContext",
  "canUseRoutingAI",
  "canUseRoutingAutopilot",
  "canUseLedgerAutomation",
  "canUseSettlementPreview",
  "canUseAccountingAI",
  "canEditWorkflows",
  "canCreateWorkflows",
  "canUseMemoryBrowser",
  "canUseMemoryGraph",
  "canUsePublicistAI",
  "canUsePressAutomation",
  "canUseOutletVariants",
  "canUsePressAnalytics",
  "canUseLeadDigestor",
  "canUseArticleEnrichment",
  "canUseDraftToneTools",
  "canUseDraftRewriteTools",
  "canUseDraftVariableAutomation",
  "canUsePressCampaigns",
  "canUsePressGraphLinks",
  "canUseMarketingAI",
  "canUseMarketingAutopilot",
  "canUseMixboardAI",
  "canUseMcpTasks",
  "canRunMasterAutopilot",
  "canRunMasterDigest",
  "canDelegateAgents",
  "canUseGlobalAutopilot",
  "canRunAiTasks",
  "autopilot_view",
  "autopilot_manage",
  "observability.frontend",
  "observability.digest",
  "plan.plus",
];

export const DEFAULT_CAPABILITIES: Capabilities = CAPABILITY_FLAGS.reduce((acc, flag) => {
  acc[flag] = flag === "canUseManagerAgent";
  return acc;
}, {} as Capabilities);
